module.exports = __webpack_public_path__ + "img/the4.df40c1f8.png";